import React from "react";

const AdminCheckbox = ({
  checked,
  onChange,
  disabled = false,
  isCategory = false,
  isForm = false,
  className = "",
  ...props
}) => {
  const checkboxStyle = {
    width: "20px",
    height: "20px",
    margin: "0",
    paddingTop: "10px",
    verticalAlign: "middle",
    marginTop: "2px",
    // Add disabled styling
    opacity: disabled ? 0.4 : 1,
    cursor: disabled ? "not-allowed" : "pointer",
  };

  const handleChange = (e) => {
    if (disabled) return; // Prevent changes if disabled
    onChange(e);
  };

  return (
    <input
      type="checkbox"
      className="checksCheckBox"
      style={checkboxStyle}
      checked={checked}
      onChange={handleChange}
      disabled={disabled}
      {...props}
    />
  );
};

export default AdminCheckbox;
